/*******************************************************
OPEN TEAM VS POSITION MODAL
Used on the team vs. position page for NFL.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';

export default function openTeamVsPosModal(event) {
    const $button = $(event.currentTarget);
    const { pos, team, scoringtype, year } = $button.data();
    const teamNameParts = ($button.siblings('a').text() || '').split(' ');
    const teamName = teamNameParts[teamNameParts.length - 1];

    // Set the table loading message
    const loadingMessage = `Loading ${teamName} vs. ${pos} Stats`;

    // Build the title
    const modalTitle = `
    <div>
        <img style="width:35px;margin-right:7px;" src="https://content.rotowire.com/images/teamlogo/football/100${team}.png"> ${teamName}<span class="light text-80 hide-until-xs" style="margin-left: 7px;">Vs. ${pos}</span>
    </div>`;

    // Build the content of the modal
    const modalContent = `
        <div id="tvp-table${team}">
            <div class="table-load"><div class="table-load__inner"><div class="loader"></div>${loadingMessage}</div></div>
        </div>`;

    // Get the modal window HTML
    const modalHTML = buildModal({
        fullWidth: true,
        title    : modalTitle,
        content  : modalContent,
    });

    // Append the modal window to the page
    $('.page').append(modalHTML);

    if (pos === 'QB') {

        loadTableRW({
            container   : `tvp-table${team}`,
            url         : `/football/tables/defense-vs-pos-gl.php?pos=QB&team=${team}&scoringtype=${scoringtype}&year=${year}`,
            emptyMessage: 'There were no stats found.',
            leftSplit   : 2,
            css         : 'no-border',
            columns     : [
                { id      : 'team',
                    header  : [{ text: '', css: 'columns-head is-dark', colspan: 2 }, { text: 'Name', css: 'align-l' }],
                    css     : 'align-l',
                    sort    : 'text-string',
                    template: '<a href="#teamURL#">#team#</a>',
                },
                { id    : 'week',
                    header: ['', { text: 'Week' }],
                    sort  : 'number',
                },

                { id    : 'points', startOfGroup: true,
                    header: [{ text: 'Fantasy', css: 'columns-head is-dark' }, { text: 'Points' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

                { id    : 'passComp', startOfGroup: true,
                    header: [{ text: 'Passing', css: 'columns-head is-dark', colspan: 6 }, { text: 'COMP' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'passAtt',
                    header: ['', { text: 'ATT' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'passYds',
                    header: ['', { text: 'YDS' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'passTD',
                    header: ['', { text: 'TD' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'passInt',
                    header: ['', { text: 'INT' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id: 'ypa',
                    header: ['', { text: 'YPA' }],
                    css: 'align-r', 
                    sort: 'number',
                },
                { id    : 'rushAtt', startOfGroup: true,
                    header: [{ text: 'Rushing', css: 'columns-head is-dark', colspan: 4 }, { text: 'ATT' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'rushYds',
                    header: ['', { text: 'YDS' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'rushTD',
                    header: ['', { text: 'TD' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id: 'ypc',
                    header: ['', { text: 'YPC' }],
                    css: 'align-r', 
                    sort: 'number',
                },
            ],

        });
    }
    else if (pos === 'RB' || pos === 'WR' || pos === 'TE') {

        loadTableRW({
            container   : `tvp-table${team}`,
            url         : `/football/tables/defense-vs-pos-gl.php?pos=${pos}&team=${team}&scoringtype=${scoringtype}&year=${year}`,
            emptyMessage: 'There were no stats found.',
            leftSplit   : 2,
            columns     : [

                { id    : 'team',
                    header: [{ text: '', css: 'columns-head is-dark', colspan: 2 }, { text: 'Name', css: 'align-l' }],
                    css   : 'align-l',
                    sort  : 'text-string',
                },
                { id    : 'week',
                    header: ['', { text: 'Week' }],
                    sort  : 'number',
                },

                { id    : 'points', startOfGroup: true,
                    header: [{ text: 'Fantasy', css: 'columns-head is-dark' }, { text: 'Points' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

                { id    : 'rushAtt', startOfGroup: true,
                    header: [{ text: 'Rushing', css: 'columns-head is-dark', colspan: 4 }, { text: 'ATT' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'rushYds',
                    header: ['', { text: 'YDS' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'rushTD',
                    header: ['', { text: 'TD' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id: 'ypc',
                    header: ['', { text: 'YPC' }],
                    css: 'align-r', 
                    sort: 'number',
                },

                { id    : 'receptions', startOfGroup: true,
                    header: [{ text: 'Receiving', css: 'columns-head is-dark', colspan: 5 }, { text: 'REC' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'recYds',
                    header: ['', { text: 'YDS' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'recTD',
                    header: ['', { text: 'TD' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'targets',
                    header: ['', { text: 'TAR' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id: 'ypt',
                    header: ['', { text: 'YPT' }],
                    css: 'align-r', 
                    sort: 'number',
                },

            ],
        });

    }
    else if (pos === 'K') {

        loadTableRW({
            container   : `tvp-table${team}`,
            url         : `/football/tables/defense-vs-pos-gl.php?pos=${pos}&team=${team}&scoringtype=${scoringtype}&year=${year}`,
            emptyMessage: 'There were no stats found.',
            leftSplit   : 2,
            columns     : [

                { id    : 'team',
                    header: [{ text: '', css: 'columns-head is-dark', colspan: 2 }, { text: 'Name', css: 'align-l' }],
                    css   : 'align-l',
                    sort  : 'text-string',
                },
                { id    : 'week',
                    header: ['', { text: 'Week' }],
                    sort  : 'number',
                },

                { id    : 'points', startOfGroup: true,
                    header: [{ text: 'Fantasy', css: 'columns-head is-dark' }, { text: 'Points' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

                { id    : 'xpm', startOfGroup: true,
                    header: [{ text: 'Extra Points', css: 'columns-head is-dark', colspan: 2 }, { text: 'XPM' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'xpa',
                    header: ['', { text: 'XPA' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

                { id    : 'fgm', startOfGroup: true,
                    header: [{ text: 'Field Goals', css: 'columns-head is-dark', colspan: 2 }, { text: 'FGM' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'fga',
                    header: ['', { text: 'FGA' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

                { id    : 'fgm29', startOfGroup: true,
                    header: [{ text: 'Field Goal Distance', css: 'columns-head is-dark', colspan: 4 }, { text: '0-29' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'fgm39',
                    header: ['', { text: '30-39' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'fgm49',
                    header: ['', { text: '40-49' }],
                    css   : 'align-r',
                    sort  : 'number',
                },
                { id    : 'fgm50',
                    header: ['', { text: '50+' }],
                    css   : 'align-r',
                    sort  : 'number',
                },

            ],
        });

    }


}
